module.exports = "<div class=\"c-editable-box c-editable-box--equal\">\n  <header class=\"c-editable-box__header\">\n    <h2 class=\"c-editable-box__title\">Datos emisor</h2>\n  </header>\n  <span class=\"h-display-block h-mb10\"><strong>GetYourHero Technology, SLU</strong></span>\n  <span class=\"h-display-block h-mb10\">B66896002</span>\n  <span class=\"h-display-block h-mb10\">C/ Marqués de Sentmenat 54, Piso 1º, Puerta 1º</span>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bills/templates/partials/emitGYH-bill.html
// module id = ./src/app/modules/bills/templates/partials/emitGYH-bill.html
// module chunks = main